var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuiserie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.945 237.025V59.8145L41.2451 17.8445V195.054L113.945 237.025Z",
    fill: "#B2E8C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.025 232.365V55.1545L113.955 59.8146V237.025L122.025 232.365Z",
    fill: "#29A063"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.865 223.035V64.4845L81.635 50.4944V209.045L105.865 223.035Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5552 204.385V45.8247L49.3252 31.8347V190.395L73.5552 204.385Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.945 59.8146L41.2451 17.8446L49.3151 13.1746L122.015 55.1545L113.945 59.8146Z",
    fill: "#72D09A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7451 136.225V126.895L81.635 125.104V134.435L84.7451 136.225Z",
    fill: "#B2E8C5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5551 129.765V120.435L70.4451 118.645V127.975L73.5551 129.765Z",
    fill: "#B2E8C5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M203.155 208.144V104.275L140.875 68.3044V172.184L203.155 208.144Z",
    fill: "#B2E8C5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M210.075 204.145V100.275L203.155 104.265V208.145L210.075 204.145Z",
    fill: "#29A063"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M196.235 148.215V108.265L175.475 96.2747V136.225L196.235 148.215Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M168.555 132.235V92.2847L147.795 80.3044V120.245L168.555 132.235Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M196.235 195.965V156.015L175.475 144.025V183.975L196.235 195.965Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M168.555 179.985V140.035L147.795 128.045V167.995L168.555 179.985Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M203.155 104.275L140.875 68.3047L147.795 64.3147L210.075 100.275L203.155 104.265V104.275Z",
    fill: "#72D09A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuiserie);
export default __webpack_public_path__ + "static/media/menuiserie.83c35a9978a6263c2e9edf37388e4106.svg";
export { ForwardRef as ReactComponent };